import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import _ from 'underscore';
import $ from 'jquery';
import { ThemeProvider } from 'react-jss';
import { ComponentSettings, ThemeFluent } from '@bingads-webui-theme-2018/theme-fluent';
import { MessageBarType } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  ImageExperience,
  PreviewCarousel,
  UnifiedPreviewCarousel,
  ImageExperienceImage,
  constants,
} from '@bingads-webui-campaign-react/image-experience';
import {
  SuggestionPoller,
  SuggestionStatus,
  mapSuggestionResponseToState,
  MediaRepository,
} from '@bingads-webui-campaign/media-repository';
import { ImageSuggestionCarousel } from '@bingads-webui-campaign-react/image-suggestion-carousel';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { isValidUrl } from '@bingads-webui/url-util';
import { mergeI18n } from '@bingads-webui-campaign-react/i18n-merger';
import {
  getAdCreatorInstrumentation,
  instrumentationScenarios,
} from '@bingads-webui-campaign/ad-creator-tools-instrumentation';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';
import { UiBlocker } from '@bingads-webui-react/ui-blocker';
import { getExtensionImagesControlStyles } from './styles';
import { getUnifiedAdPreviewConfig } from './get-unified-ad-preview-config';

export class ExtensionImagesControlBase extends React.PureComponent {
  static propTypes = {
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
      parseDecimal: PropTypes.func.isRequired,
    }).isRequired,
    genericImage: PropTypes.string.isRequired,
    perfMarker: PropTypes.shape({
      willFetchFile: PropTypes.func.isRequired,
      willInit: PropTypes.func.isRequired,
      willFetchData: PropTypes.func.isRequired,
      willRender: PropTypes.func.isRequired,
      done: PropTypes.func.isRequired,
      createChild: PropTypes.func.isRequired,
    }),
    cid: PropTypes.string.isRequired,
    aid: PropTypes.string.isRequired,
    imageList: PropTypes.arrayOf(PropTypes.instanceOf(ImageExperienceImage)).isRequired,
    text: PropTypes.string,
    url: PropTypes.string,
    eligibleLayouts: PropTypes.string,
    onImageListChanged: PropTypes.func,
    isForVNext: PropTypes.bool,
    isStockPhotoEnabled: PropTypes.bool,
    isImageFittingEnabled: PropTypes.bool,
    oDataConfig: PropTypes.shape({
      odataRootUrl: PropTypes.string,
      odataPath: PropTypes.string,
      odataToken: PropTypes.string,
    }),
    staticImagePath: PropTypes.string,
    permissions: PropTypes.shape({
      IsStockPhotoFilterEnabled: PropTypes.bool,
      dynamic: PropTypes.shape({ ImageExtensionsEnhancements: PropTypes.bool, AdPreviewRefresh: PropTypes.bool }),
    }),
    newI18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }),
    recommendation: PropTypes.objectOf(PropTypes.any),
    readOnly: PropTypes.bool,
    instrumentation: PropTypes.shape({}),
    preferencesService: PropTypes.shape({}),
    subscribeToUrlChanged: PropTypes.func,
    setFullUrl: PropTypes.func,
    setError: PropTypes.func,
    classes: PropTypes.shape({
      carouselParent: PropTypes.string,
      viewAllPlacementsButton: PropTypes.string,
      reCropButton: PropTypes.string,
    }),
    setImageControlSetText: PropTypes.func,
    setImageControlsValidate: PropTypes.func,
    setImageControlSetEligibleLayout: PropTypes.func,
  };

  static defaultProps = {
    perfMarker: {
      willFetchFile: _.noop,
      willInit: _.noop,
      willFetchData: _.noop,
      willRender: _.noop,
      done: _.noop,
      createChild: _.noop,
    },
    text: '',
    url: '',
    eligibleLayouts: '',
    onImageListChanged: _.noop,
    isForVNext: false,
    isStockPhotoEnabled: false,
    isImageFittingEnabled: false,
    oDataConfig: null,
    staticImagePath: null,
    permissions: {},
    newI18n: PropTypes.shape({
      getString: _.noop,
    }),
    recommendation: {},
    readOnly: false,
    instrumentation: {},
    preferencesService: {},
    subscribeToUrlChanged: _.noop,
    setFullUrl: _.noop,
    setError: _.noop,
    classes: {},
    setImageControlSetText: _.noop,
    setImageControlsValidate: _.noop,
    setImageControlSetEligibleLayout: _.noop,
  };

  constructor(props) {
    super(props);

    this.perfMarker = props.perfMarker;
    this.newI18n = this.props.newI18n;
    this.oldI18n = mergeI18n(
      window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/audience-campaign'),
      this.newI18n
    );

    this.defaultPreviewFields = {
      shortHeadline: props.i18n.getString('Image_Extension_Ad_Preview_Default_ShortHeadline'),
      longHeadline: props.i18n.getString('Image_Extension_Ad_Preview_Default_LongHeadline'),
      description: props.i18n.getString('Image_Extension_Ad_Preview_Default_Description'),
      businessName: props.i18n.getString('Image_Extension_Ad_Preview_Default_BusinessName'),
      url: 'https://example.com',
    };

    this.state = {
      imageList: this.props.imageList,
      previewTexts: this.getPreviewTexts(props.text, props.url),
      errors: [],
      ...mapSuggestionResponseToState(SuggestionStatus.EmptyURL),
      protocol: 'https://',
      eligibleLayout: this.props.eligibleLayouts,
    };

    this.previewCarouselRef = React.createRef();

    if (this.props.permissions.dynamic.ImageExtensionsEnhancements) {
      this.props.subscribeToUrlChanged(this.finalUrlChanged.bind(this));
    }
    // set the theme in the constructor because it shouldn't be instantiated on every re-render
    // setting this in ThemeProvider wrapper caused generation of a new panel class name
    this.theme = { components: ComponentSettings, core: ThemeFluent };

    this.props.setImageControlSetText(this.setText.bind(this));

    this.props.setImageControlsValidate(this.validate.bind(this));

    this.props.setImageControlSetEligibleLayout(this.setEligibleLayout.bind(this));

    let adCreatorInstrumentation = {};
    try {
      adCreatorInstrumentation = getAdCreatorInstrumentation(
        this.props.instrumentation,
        this.adCreatorScenario,
        this.props.permissions
      ) || {};
    // eslint-disable-next-line no-empty
    } catch (e) {}

    if (this.props.permissions.dynamic.ImageExtensionsEnhancements) {
      this.suggestionPoller = new SuggestionPoller({
        cid: props.cid,
        aid: props.aid,
        oDataConfig: props.oDataConfig,
        jobCompleteCallback: this.onPollingSuggestionCompleted.bind(this),
        logger: adCreatorInstrumentation.websiteSuggestionActivity,
      });
    }

    const { cid, aid, oDataConfig } = this.props;
    this.mediaRepository = new MediaRepository({ cid, aid, oDataConfig });

    this.enableAdPreviewLibrary = _.get(props.permissions.dynamic, 'AdPreviewLibrarySearchMMA', false);

    const activityLogger = adCreatorInstrumentation.editImageActivity;
    if (activityLogger) {
      activityLogger.signal('image extension panel open', 'image extension');
    }
    this.adCreatorInstrumentation = adCreatorInstrumentation;
  }

  componentWillUnmount() {
    if (this.suggestionPoller) {
      this.suggestionPoller.cancel();
    }
  }

  onPollingSuggestionCompleted(response, isSubdomainScraping) {
    if (response.error) {
      // error handling section
      this.setState(mapSuggestionResponseToState(SuggestionStatus.ServerError, response));
    } else {
      this.setState(mapSuggestionResponseToState(
        SuggestionStatus.FetchSucceed,
        response,
        isSubdomainScraping
      ));
    }
  }

  onImageListUpdated = (imageList) => {
    this.setState({
      cropImage: null,
      replaceImage: null,
      imageList,
    });

    this.validate(imageList);

    this.props.onImageListChanged(imageList);
  };

  onImagePreviewRequested = (type) => {
    this.previewCarouselRef.current.setPreviewIndexByType(type);
  };

  onUpdateFinalUrlPrefix = (ev, newPrefix) => {
    this.setState({ protocol: newPrefix.text });
  };

  onUpdateFinalUrl = (ev) => {
    // const newUrl = ev && ev.target && ev.target.value;
    const newUrl = ev.target.value;
    const newUrlWithProtocol = this.state.protocol + newUrl;
    this.finalUrlChanged(newUrlWithProtocol);
    this.props.setFullUrl(newUrlWithProtocol);
  };

  onImageCropCancelled = () => {
    this.setState({
      cropImage: null,
    });
  };

  onImageReplaceCancelled = () => {
    this.setState({
      replaceImage: null,
    });
  };

  setAddNewImageCallback = (callback) => {
    this.setState({ addImageCallback: callback });
  };

  setOpenAddImageCallback = (callback) => {
    this.setState({ openAddImageCallback: callback });
  };

  setErrors(errorMessages) {
    this.setState({
      errors: errorMessages,
    });
  }

  setText(newText) {
    this.setState({
      previewTexts: this.getPreviewTexts(newText, this.state.url),
    });
  }

  setEligibleLayout(newEligibleLayout) {
    this.setState({
      eligibleLayout: newEligibleLayout,
    });
  }

  getPreviewTexts(text) {
    const processedText = _.isString(text) ? text.trim() : null;

    return {
      shortHeadline: this.defaultPreviewFields.shortHeadline,
      longHeadline: this.defaultPreviewFields.longHeadline,
      description: this.defaultPreviewFields.description,
      businessName: this.defaultPreviewFields.businessName,
      url: this.defaultPreviewFields.url,
      extensionHeadline: processedText,
    };
  }

  finalUrlChanged = (newUrlWithProtocol) => {
    let newState = {};
    if (!isValidUrl(newUrlWithProtocol)) {
      newState = mapSuggestionResponseToState(SuggestionStatus.InvalidURL);
      this.props.setError(this.props.i18n.getString('API_ErrorNumber_2611'));
    } else {
      newState = mapSuggestionResponseToState(SuggestionStatus.FetchInProgress);
      this.props.setError('');
    }

    this.setState(
      _.extend({ url: newUrlWithProtocol }, newState),
      () => {
        if (isValidUrl(newUrlWithProtocol)) {
          this.fetchSuggestions(newUrlWithProtocol);
        }
      }
    );
  };

  fetchSuggestions = _.debounce((url) => {
    this.suggestionPoller.cancel();
    const minimumSize = constants.getMinimumSizeForImage(null);
    this.suggestionPoller.getLandingPageSuggestions({
      landingPageUrl: url,
      minimumResolution: {
        width: minimumSize[0],
        height: minimumSize[1],
      },
    });
  }, 1000);

  validate(imageList) {
    const imageListToValidate = imageList || this.state.imageList;
    const errors = [];

    if (imageListToValidate.length === 0) {
      errors.push(this.props.i18n.getString('ImageAdExtensionV2_ImagesRequired'));
    } else {
      const typesPresent = _.map(
        imageListToValidate,
        imageExperienceImage => imageExperienceImage.type
      );
      const typesMissing = _.difference(constants.imageTypesWithOrder, typesPresent);

      if (typesMissing.length > 0) {
        const typeMissingStrings = _.map(
          typesMissing,
          type => this.props.i18n.getString(constants.aspectRatios[type].stringKey)
        );

        const errMsg = `${this.props.i18n.getString('ImageAdExtensionV2_MissingPartialImages')} ${typeMissingStrings.join(', ')}`;

        errors.push(errMsg);
      }
    }

    this.setState({
      errors,
    });

    return errors.length === 0;
  }

  render() {
    const enhancedImageExperienceProps =
      this.props.permissions.dynamic.ImageExtensionsEnhancements ? {
        onUpdateFinalUrl: this.onUpdateFinalUrl,
        onUpdateFinalUrlPrefix: this.onUpdateFinalUrlPrefix,
        suggestion: this.state.suggestion,
        suggestionPoller: this.suggestionPoller,
        finalUrl: this.state.url,
        finalUrlProtocol: this.state.protocol,
        setAddNewImageCallback: this.setAddNewImageCallback,
        setOpenAddImageCallback: this.setOpenAddImageCallback,
        cropImage: this.state.cropImage,
        onImageCropCancelled: this.onImageCropCancelled,
        onImageReplaceCancelled: this.onImageReplaceCancelled,
        replaceImage: this.state.replaceImage,
      } : {};
    const enhancedPreviewCarouselProps =
      this.props.permissions.dynamic.ImageExtensionsEnhancements ? {
        onCropImage: (imgObj) => {
          this.setState({
            cropImage: imgObj,
          });
        },
        onReplaceImage: (imgObj) => {
          this.setState({
            replaceImage: imgObj,
          });
        },
        customClasses: {
          viewAllPlacementsButton: this.props.classes.viewAllPlacementsButton,
          reCropButton: this.props.classes.reCropButton,
        },
      } : {};
    if (this.props.permissions.dynamic.ImageExtensionsEnhancements && $('.suggestion-carousel').length > 0) {
      ReactDOM.render(
        <ThemeProvider theme={this.theme}>
          <UiBlocker
            blocking={this.state.blockCarousel}
            loadingText={this.props.i18n.getString('Loading')}
          >
            {this.state.imageList.length === 0 &&
            <ImageSuggestionCarousel
              customClasses={{
                carouselParent: this.props.classes.carouselParent,
                }}
              isLoading={!!this.state.suggestion.inProgress}
              images={this.state.carousel.images || []}
              i18n={this.props.newI18n}
              isEmpty={this.state.carousel.isError}
              messageInfo={this.state.carousel.message}
              onSelectImage={(imageSource, index) => {
                  const { websiteSuggestionCarouselActivity } =
                    getAdCreatorInstrumentation(
                      this.props.instrumentation,
                      this.adCreatorScenario
                      );

                  websiteSuggestionCarouselActivity.trace(`CarouselImageSelected: ${index};`);

                  this.setState({ blockCarousel: true });
                  this.state.addImageCallback(imageSource)
                  .then((error = {}) => {
                    if (error && error.errorMessage) {
                      this.setState({
                        carousel: {
                          ...this.state.carousel,
                          message: {
                            type: MessageBarType.error,
                            message: error.errorMessage,
                          },
                        },
                      });
                    }
                    return Promise.resolve();
                  })
                  .finally(() => {
                    this.setState({ blockCarousel: false });
                  });
                  this.setState({
                    carousel: {
                      ...this.state.carousel,
                      images: _.reject(this.state.carousel.images, (val, ind) => ind === index),
                    },
                  });
                }}
              onSelectSeeAll={() => this.state.openAddImageCallback()}
            />
          }
          </UiBlocker>
        </ThemeProvider>,
        $('.suggestion-carousel')[0]
      );
    }

    const isAdPreviewRefreshEnabled = this.props.permissions.dynamic.AdPreviewRefresh;
    const PreviewCarouselComponent = this.enableAdPreviewLibrary ? UnifiedPreviewCarousel : PreviewCarousel;
    const adPreviewConfig = getUnifiedAdPreviewConfig({ eligibleLayout: this.state.eligibleLayout, isAdPreviewRefreshEnabled });

    return (
      <ThemeProvider theme={this.theme}>
        <div className="extension-images-control">
          <I18nContext.Provider value={this.newI18n}>
            <InstrumentationContext.Provider value={this.props.instrumentation}>
              <ImageExperience
                cid={this.props.cid}
                aid={this.props.aid}
                i18n={this.oldI18n}
                mediaRepository={this.mediaRepository}
                imageList={this.state.imageList}
                perfMarker={this.perfMarker}
                onImageListUpdated={this.onImageListUpdated}
                onImagePreviewRequested={this.onImagePreviewRequested}
                extensionHeadline={this.state.previewTexts.extensionHeadline}
                isImageAdExtensionMode
                genericImage={this.props.genericImage}
                isForVNext={this.props.isForVNext}
                oDataConfig={this.props.oDataConfig}
                isStockPhotoEnabled={this.props.isStockPhotoEnabled}
                staticImagePath={this.props.staticImagePath}
                permissions={this.props.permissions}
                recommendation={this.props.recommendation}
                readOnly={this.props.readOnly}
                adCreatorScenario={instrumentationScenarios.default}
                instrumentation={this.props.instrumentation}
                preferencesService={this.props.preferencesService}
                isFinalUrlImageRetrievalEnabled={
                  this.props.permissions.dynamic.ImageExtensionsEnhancements
                }
                isImageExtensionsEnhancementsEnabled={
                  this.props.permissions.dynamic.ImageExtensionsEnhancements
                }
                activityLogger={this.adCreatorInstrumentation && this.adCreatorInstrumentation.editImageActivity}
                {...enhancedImageExperienceProps}
                enableUnifiedAdPreview={this.enableAdPreviewLibrary}
                adPreviewConfig={adPreviewConfig}
                isImageFittingEnabled={this.props.isImageFittingEnabled}
                isAdPreviewRefreshEnabled={isAdPreviewRefreshEnabled}
              />
            </InstrumentationContext.Provider>
            {
              this.state.errors.map(errMsg => (
                <div
                  className="error"
                  key={errMsg}
                >
                  {errMsg}
                </div>
              ))
            }
            <PreviewCarouselComponent
              ref={this.previewCarouselRef}
              imageList={this.state.imageList}
              previewTexts={this.state.previewTexts}
              eligibleLayout={this.state.eligibleLayout}
              i18n={this.props.i18n}
              genericImage={this.props.genericImage}
              isImageAdExtensionMode
              isForVNext={this.props.isForVNext}
              totalImageListCount={this.state.imageList.length}
              isImageExtensionsEnhancementsEnabled={
                this.props.permissions.dynamic.ImageExtensionsEnhancements
              }
              instrumentation={this.props.instrumentation}
              {...enhancedPreviewCarouselProps}
              adPreviewConfig={adPreviewConfig}
              enableUnifiedAdPreview={this.enableAdPreviewLibrary}
              isImageFittingEnabled={this.props.isImageFittingEnabled}
              permissions={this.props.permissions}
            />
          </I18nContext.Provider>
        </div>
      </ThemeProvider>
    );
  }
}

export const ExtensionImagesControl =
  withDefaultStyles(ExtensionImagesControlBase, getExtensionImagesControlStyles);

